module.exports = ".table{\n    margin: auto;\n    width: 90%;\n}\n\nh1{\n  font-family: helvetica;\n  \n}\n"